import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const formulariFormDatiTrasportoQuantita : AnaColumn[]= [

    {
      itemType: "group", class: "colonnaForm-50", groupDataField: 'datiTrasportoPartenza', caption: 'Dati Autista', colCount: "1", data: [
  
  
        { type: 'campo', colVisible: false, dataField: 'idTrasportatore', dataType: "", hideOnEdit: true, colSpan: '2' },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteNome', dataType: "", hideOnEdit: false, caption: "Nome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
        },
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaConducenteCognome', dataType: "", hideOnEdit: false, caption: "Cognome",
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
          maxSize: 50,
          maxLength: "50",
          width: 57.8 * aspect,
        },
      ]
    },
    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', class: "colonnaForm-50", caption: 'Dati Veiolo', colCount: "1", data: [
  
  
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaAutomezzo', dataType: "", hideOnEdit: false, caption: "Targa Automezzo",
          width: 17 * aspect,
          maxLength: "7",
          maxSize: 7,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campo', colVisible: false, dataField: 'datiTrasportoPartenzaTargaRimorchio', dataType: "",
          hideOnEdit: false, caption: "Targa Rimorchio",
          width: 17 * aspect,
          maxLength: "7",
          maxSize: 7,
        },
      ]
    },
    {
      itemType: "group", groupDataField: 'datiTrasportoPartenza', caption: 'Data e Ora della partenza', colSpan: '2', data: [
  
        {
          type: 'campoData', dataField: "datiTrasportoPartenzaDataInizioTrasporto", format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "datetime", caption: "Data Partenza", width: 18.2 * aspect,
  
          /* validation: [
             { type: "required", message: "Campo Obbligatorio" }
           ],*/
        },
        {
          type: 'campoData', caption: 'Ora Partenza', colVisible: false, dataField: 'datiTrasportoPartenzaOraInizioTrasporto', dataType: "time", editorType: 'dxDateBox', hideOnEdit: false,
          format: 'HH:mm',
          width: 18.2 * aspect,
          /*validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],*/
        },
  
  
        { type: 'campo', caption: 'Annotazioni', colVisible: false, dataField: 'datiTrasportoPartenzaAnnotazioni', dataType: "", hideOnEdit: false, editorType: 'dxTextArea' },
  
      ]
  
    },
  
    {
      itemType: "group", groupDataField: '', caption: 'Quantità Rifiuto', colCount: "2", colSpan: '2', data: [
  
  
        {
          type: 'campo', colVisible: false, dataField: 'denominazioneFirmatario', hideOnEdit: true, caption: 'denominazioneFirmatario',
          width: 45 * aspect,
          maxLength: '40',
  
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'identificativoFirmatario', dataType: "", hideOnEdit: true, caption: 'identificativoFirmatario',
          width: 15 * aspect,
          maxLength: '10',
  
  
        },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'valore', dataType: "number", hideOnEdit: false, caption: 'Quantità',
          width: 15 * aspect,
          maxLength: '10',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'pesolordo', dataType: "number", caption: 'Peso lordo', hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campo', colVisible: false, dataField: 'tara', dataType: "number", hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'um', dataType: "", hideOnEdit: false, caption: 'Unità misura',
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'um',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: true
          },
          width: 15 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        { type: 'campo', colVisible: false, dataField: 'verificareADestino', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Verificare a destino', hideOnEdit: false },
  
      ]
    }
  ]